import React, { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { FileUpload } from "primereact/fileupload";
import { ProgressBar } from "primereact/progressbar";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Tag } from "primereact/tag";
import { toastAlert } from "../core/utils";
import { AssignmentService } from "../service/AssignmentService";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import ButtonsActions from "./ButtonsActions";

function DesignsUpload({ data, format, alert, updateData, hide, uploadNotify, editData = null }) {
    const dataService = useRef(new AssignmentService());
    const toast = useRef(null);
    const fileUploadRef = useRef(null);

    const [state, setState] = useState({
        totalSize: 0,
        upload: null,
        fileName: "",
        urlEnglish: "",
        urlSpanish: "",
        languages: [],
        loading: false,
        isEditMode: !!editData,
        fileId: null
    });

    useEffect(() => {
        const languages = data._LANGUAGES?.split(",") || [];
        
        if (state.isEditMode && editData) {
            setState(prev => ({
                ...prev,
                fileName: editData._FILENAME,
                urlEnglish: editData._FILEURLENGLISH || "",
                urlSpanish: editData._FILEURLSPANISH || "",
                fileId: editData._FILEID,
                languages
            }));
        } else {
            setState(prev => ({ ...prev, languages }));
        }
    }, [data._LANGUAGES, editData, state.isEditMode]);

    const handleInputChange = (field) => (e) => {
        setState((prev) => ({ ...prev, [field]: e.target.value }));
    };

    const sendData = async () => {
        setState((prev) => ({ ...prev, loading: true }));

        try {

            let setStatus = state.isEditMode ? "SAVED" : "ADDED";

            const payload = {
                _FILENAME: state.fileName,
                _ID: data._IDASSIGNMET,
                _IDCAMPAIGN: data._IDCAMPAIGN,
                _FORMAT: format,
                _FILEURLENGLISH: state.urlEnglish,
                _FILEURLSPANISH: state.urlSpanish,
                _FILESTATUS: setStatus,
                ...(state.isEditMode && { _FILEID: state.fileId })
            };

            const response = state.isEditMode 
                ? await dataService.current.updateDesigns(payload)
                : await dataService.current.addDesigns(payload);

            if (response._SUCCESS) {
                const lastItem = state.isEditMode ? response._ITEMS : response._ITEMS;
                
                updateData(lastItem);
                
                uploadNotify();
                alert("success", response._MESSAGE, toast);
            } else {
                alert("warn", response._MESSAGE, toast);
            }
        } catch (error) {
            
            alert(error.variant, error.data, toast);
        } finally {
            setState((prev) => ({ ...prev, loading: false }));
            hide();
        }
    };

    const hasLanguage = (lang) => state.languages.includes(lang) || data._LANGUAGES === lang;

    return (
        <div className="w-full">
            <Toast ref={toast} />

            <Tooltip target=".custom-choose-btn" content="Choose" position="bottom" />
            <Tooltip target=".custom-upload-btn" content="Upload" position="bottom" />
            <Tooltip target=".custom-cancel-btn" content="Clear" position="bottom" />

            <div className="field">
                <label htmlFor="name" className="block">
                    Design Name
                </label>
                <span className="p-input-icon-left w-full">
                    <i className="pi pi-image text-pink-500" />
                    <InputText 
                        id="name" 
                        value={state.fileName} 
                        onChange={handleInputChange("fileName")} 
                        className="block w-full" 
                        placeholder="Design Campaign 001" 
                        disabled={state.isEditMode}
                    />
                </span>
            </div>

            {hasLanguage("ENGLISH") && (
                <div className={`field ${data._LANGUAGES === "ENGLISH" ? "mb-8" : ""}`}>
                    <label htmlFor="url" className="block">
                        Url from Design <b>ENGLISH</b>
                    </label>
                    <span className="p-input-icon-left w-full">
                        <i className="pi pi-globe text-pink-500" />
                        <InputText 
                            id="url" 
                            aria-describedby="url-help" 
                            value={state.urlEnglish} 
                            onChange={handleInputChange("urlEnglish")} 
                            className="block w-full" 
                            placeholder="https://letusclaimcons.sharepoint.com" 
                        />
                    </span>
                    <small id="url-help" className="block">
                        Enter the url of the design.
                    </small>
                </div>
            )}

            {hasLanguage("SPANISH") && (
                <div className="field mb-8">
                    <label htmlFor="url" className="block">
                        Url from Design <b>SPANISH</b>
                    </label>
                    <span className="p-input-icon-left w-full">
                        <i className="pi pi-globe text-pink-500" />
                        <InputText 
                            id="url" 
                            aria-describedby="url-help" 
                            value={state.urlSpanish} 
                            onChange={handleInputChange("urlSpanish")} 
                            className="block w-full" 
                            placeholder="https://letusclaimcons.sharepoint.com" 
                        />
                    </span>
                    <small id="url-help" className="block">
                        Enter the url of the design.
                    </small>
                </div>
            )}

            <ButtonsActions 
                cancel={hide} 
                submit={sendData} 
                submitText={state.isEditMode ? "Update" : "Submit"} // Cambiamos el texto del botón
            />

            <LoadingDialog 
                visible={state.loading} 
                format={format} 
                onHide={() => setState((prev) => ({ ...prev, loading: false }))} 
                actionText={state.isEditMode ? "Updating" : "Uploading"} // Texto dinámico
            />
        </div>
    );
}

const LoadingDialog = ({ visible, format, onHide, actionText = "Uploading" }) => (
    <Dialog visible={visible} style={{ width: "450px" }} showHeader={false} modal onHide={onHide}>
        <div className="text-center">
            <div className="grid">
                <div className="col-12">
                    {format && (
                        <p className="text-2xl p-4">
                            {actionText} design format <b>{format}</b>, please wait...
                        </p>
                    )}
                </div>
                <div className="col-12">
                    <ProgressBar mode="indeterminate" className="w-full text-color h-1rem" />
                </div>
            </div>
        </div>
    </Dialog>
);

export default DesignsUpload;